import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import "./styles/app.css";

/**
 * The static web app's entry point (R22 T10).
 *
 * `BrowserRouter` rather than a hash router, because the URLs have to stay the
 * ones the Next host serves: they are in WhatsApp messages already sent and in
 * bookmarks. The other half of that promise is the server's, and it is the one
 * thing the SPA needs from its host: any unknown path must return `index.html`
 * rather than a 404, or a deep link fails on a cold load while working fine
 * from inside the app. T16 wires that up on the Worker.
 */
const container = document.getElementById("root");
if (!container) throw new Error("No #root element in index.html");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
